import { format } from 'date-fns';
import { Link, withPrefix } from "gatsby";
import React, { useContext } from "react";
import Context from "../../context/Context";
import { useEventContext } from "../../context/EventProvider";
import useAuthModal from "../../hooks/useAuthModal";
import { Social } from "../../interfaces/interfaces";
import { createFormattedTimeRange } from "../../utils/dates";
import { AuthLink } from "../links";
import PresentedInfo from "../presented";
import { SocialSection } from "../styled";

export const RegisterButton = () => (
  <AuthLink
    key={"nav-hero"}
    to={"/?"}
    target="_self"
>
  <button className="registerButton">Register</button>
</AuthLink>
);

const NewHero = () => {
  const { event: {
    url,
    email,
    emailSubject,
    starts,
    ends,
    virtualStart,
    virtualEnd,
    timezone,
    siteName,
    addresses,
  }, virtual } = useEventContext();
  const { user } = useAuthModal();
  const data = useContext(Context);
  const { socialShare } = data;

  const locationName = addresses.length > 0 && addresses[0].location;
  // TODO: Add Strapi Event attribute for forcing TZ abbreviation.
  // When forcing the timezone abbreviation to ET, we can retrieve from Strapi
  const inPersonTimeRange = createFormattedTimeRange(starts, ends, timezone, 'ET');
  const virtualTimeRange = createFormattedTimeRange(virtualStart, virtualEnd, timezone, 'ET');
  const startDateUtc = new Date(starts);
  const formattedStartDate = format(startDateUtc, 'MMMM d', {});
  const eventTime = virtual ? virtualTimeRange : inPersonTimeRange;
  const eventLocation = virtual ? 'VIRTUAL EXPERIENCE' : locationName;
  const eventTimeAndLocation = `${eventTime} | ${eventLocation}`;

  return (
    <div id="top">
      <div className="hero-container">
        <div className="hero-desktop">
          <img
            src="https://cdn.ems.prod.upgather.com/uploads/Background_GDIT_5adb355809.png"
            alt="Desktop Background"
          />
          <div className="hero-content">
            <img src="https://cdn.ems.prod.upgather.com/uploads/gdit_lockup_1992a1a8df.svg" alt="GDIT" className="gdit-svg" style={{maxWidth: '300px', width: '100%'}}/>
            <h1 className="gdit-event-title"><span>EMERGE:</span>AI on the Frontlines</h1>
            <img src="https://cdn.fedscoop.com/upgather/gdit/orangeline.png" alt="orange divider" style={{maxWidth: '125px', width: '100%', marginTop: '5px', marginBottom: '5px'}}></img>
            {/*<div className="hero-event-date">{formattedStartDate}</div>*/}
            {/*<img
              src="https://cdn.ems.prod.upgather.com//uploads/AI_Talks_Main_Hero_Logo_511462d92b.svg"
              alt={`${siteName} Desktop Hero Background`}
              className="hero-event-title"
  />*/}
            <h2 className="gdit-event-subtitle">Advanced AI Meets Mission Realities</h2>
            <div className="hero-event-time">
              {formattedStartDate} | {eventTimeAndLocation}
            </div>
            <RegisterButton />
            <div className="collaboration">IN COLLABORATION WITH</div>
            <img src="https://cdn.ems.prod.upgather.com/uploads/googleforgov_white_14f658519b.svg" alt="Google for Government" className="google-svg" style={{marginTop: '20px',maxWidth: '353px', width: '100%'}}/>
            {/*<br />
            <PresentedInfo />*/}
          </div>
        </div>
        <div className="hero-mobile">
        <img
            src="https://cdn.ems.prod.upgather.com/uploads/Background_GDIT_5adb355809.png"
            alt="Desktop Background"
          />
          <div className="hero-content">
          <img src="https://cdn.ems.prod.upgather.com/uploads/gdit_lockup_1992a1a8df.svg" alt="GDIT" className="gdit-svg" style={{maxWidth: '300px', width: '100%'}}/>
            <h1 className="gdit-event-title"><span>EMERGE:</span><br />AI on the Frontlines</h1>
            <img src="https://cdn.fedscoop.com/upgather/gdit/orangeline.png" alt="orange divider" style={{maxWidth: '125px', width: '100%', marginTop: '5px', marginBottom: '5px'}}></img>
            {/*<div className="hero-event-date">{formattedStartDate}</div>*/}
            {/*<img
              src="https://cdn.ems.prod.upgather.com//uploads/AI_Talks_Main_Hero_Logo_511462d92b.svg"
              alt={`${siteName} Desktop Hero Background`}
              className="hero-event-title"
  />*/}
            <h2 className="gdit-event-subtitle">Advanced AI Meets Mission Realities</h2>
            <div className="hero-event-time">
              {formattedStartDate} | {eventTimeAndLocation}
            </div>
            <RegisterButton />
            <div className="collaboration">IN COLLABORATION WITH</div>
            <img src="https://cdn.ems.prod.upgather.com/uploads/googleforgov_white_14f658519b.svg" alt="Google for Government" className="google-svg" style={{marginTop: '20px',maxWidth: '353px', width: '100%'}}/>
            {/*<br />
            <PresentedInfo />*/}
          </div>
        </div>
      </div>
      <div className="socials">
        {socialShare &&
          socialShare.map((social: Social, index: number) => (
            <SocialSection key={index}>
              <a
                href={
                  social.alt === "email"
                    ? `${social.path}${email}?subject=${emailSubject}`
                    : `${social.path}${url}`
                }
                target="__blank"
              >
                <img src={withPrefix(social.img)} alt={social.alt} />
              </a>
            </SocialSection>
          ))}
      </div>
    </div>
  );
};

export default NewHero;
